export default "__VITE_ASSET__5eed0e42__"